import moment from 'moment';
import { unloadTypes } from '../pages/Scheduling/util/scheduling';
import { luftGet, luftPost } from '../shared/http';

// ================================
// ACTIONS
// ================================
const UNLOAD_ADD_NF_TO_LIST = 'luft/scheduling/UNLOAD_ADD_NF_TO_LIST';
const UNLOAD_REMOVE_NF_FROM_LIST = 'luft/scheduling/UNLOAD_REMOVE_NF_FROM_LIST';
const UNLOAD_CHANGE_TYPE = 'luft/scheduling/UNLOAD_CHANGE_TYPE';
const UNLOAD_EDIT_DAMAGED_NF = 'luft/scheduling/UNLOAD_EDIT_DAMAGED_NF';
const UNLOAD_EDIT_PALLETIZED_NF = 'luft/scheduling/UNLOAD_EDIT_PALLETIZED_NF';

const LOAD_SELECT_NF = 'luft/scheduling/LOAD_SELECT_NF';

const SELECT_TYPE = 'luft/scheduling/SELECT_TYPE';
const SELECT_DRIVER_LOAD = 'luft/scheduling/SELECT_DRIVER_LOAD';
const SELECT_DRIVER_UNLOAD = 'luft/scheduling/SELECT_DRIVER_UNLOAD';
const SELECT_VEHICLE_LOAD = 'luft/scheduling/SELECT_VEHICLE_LOAD';
const SELECT_VEHICLE_UNLOAD = 'luft/scheduling/SELECT_VEHICLE_UNLOAD';
const SELECT_DAY = 'luft/scheduling/SELECT_DAY';
const SELECT_SCHEDULES = 'luft/scheduling/SELECT_SCHEDULES';

const LOCK_SCHEDULES = 'luft/scheduling/LOCK_SCHEDULES';

const CHANGE_STEP = 'luft/scheduling/CHANGE_STEP';
const NEXT_STEP = 'luft/scheduling/NEXT_STEP';

const LOAD_GET_NF_LIST = 'luft/scheduling/LOAD_GET_NF_LIST';
const LOAD_GET_NF_LIST_SUCCESS = 'luft/scheduling/LOAD_GET_NF_LIST_SUCCESS';
const LOAD_GET_NF_LIST_FAILURE = 'luft/scheduling/LOAD_GET_NF_LIST_FAILURE';

const GET_DRIVERS = 'luft/scheduling/GET_DRIVERS';
const GET_DRIVERS_SUCCESS = 'luft/scheduling/GET_DRIVERS_SUCCESS';
const GET_DRIVERS_FAILURE = 'luft/scheduling/GET_DRIVERS_FAILURE';

const GET_VEHICLES = 'luft/scheduling/GET_VEHICLES';
const GET_VEHICLES_SUCCESS = 'luft/scheduling/GET_VEHICLES_SUCCESS';
const GET_VEHICLES_FAILURE = 'luft/scheduling/GET_VEHICLES_FAILURE';

const GET_AVAILABLE_DATES = 'luft/scheduling/GET_AVAILABLE_DATES';
const GET_AVAILABLE_DATES_SUCCESS =
  'luft/scheduling/GET_AVAILABLE_DATES_SUCCESS';
const GET_AVAILABLE_DATES_FAILURE =
  'luft/scheduling/GET_AVAILABLE_DATES_FAILURE';

const GET_AVAILABLE_HOURS = 'luft/scheduling/GET_AVAILABLE_HOURS';
const GET_AVAILABLE_HOURS_SUCCESS =
  'luft/scheduling/GET_AVAILABLE_HOURS_SUCCESS';
const GET_AVAILABLE_HOURS_FAILURE =
  'luft/scheduling/GET_AVAILABLE_HOURS_FAILURE';

const ADD_SCHEDULE = 'luft/scheduling/ADD_SCHEDULE';
const ADD_SCHEDULE_SUCCESS = 'luft/scheduling/ADD_SCHEDULE_SUCCESS';
const ADD_SCHEDULE_FAILURE = 'luft/scheduling/ADD_SCHEDULE_FAILURE';
const ADD_SCHEDULE_CLEAR = 'luft/scheduling/ADD_SCHEDULE_CLEAR';

const GET_PACKAGING_TYPES = 'luft/scheduling/GET_PACKAGING_TYPES';
const GET_PACKAGING_TYPES_SUCCESS =
  'luft/scheduling/GET_PACKAGING_TYPES_SUCCESS';
const GET_PACKAGING_TYPES_FAILURE =
  'luft/scheduling/GET_PACKAGING_TYPES_FAILURE';

// ================================
// INITIAL STATE
// ================================
const initialState = {
  // SHARED STATE
  addSchedule: {
    isFetching: false,
    requested: '',
    error: '',
  },
  drivers: {
    isFetching: false,
    requested: '',
    error: '',
    list: [],
  },
  vehicles: {
    isFetching: false,
    requested: '',
    error: '',
    list: [],
  },
  availableDates: {
    isFetching: false,
    requested: '',
    error: '',
    list: [],
  },
  availableHours: {
    isFetching: false,
    requested: '',
    error: '',
    list: [],
  },
  currentType: null,
  currentStep: 1,
  availableStep: 1,
  selectedDay: null,
  selectedSchedules: [],
  lockScheduleStatus: false,
  packagingTypes: {
    isFetching: false,
    requested: '',
    error: '',
    list: [],
  },

  // UNLOAD SCHEDULE FLOW STATE
  unloadSchedule: {
    nfList: [],
    unloadType: null,
    selectedDriver: {},
    selectedVehicle: {},
    dateTimeFrom: '',
    dateTimeTo: '',
  },

  // LOAD SCHEDULE FLOW STATE
  loadSchedule: {
    nfList: {
      isFetching: false,
      requested: '',
      error: '',
      list: [],
      totalItems: 0,
    },
    nfSelectedsList: [],
    unloadType: unloadTypes.UNLOAD_DELIVERY,
    selectedDriver: {},
    selectedVehicle: {},
    dateTimeFrom: '',
    dateTimeTo: '',
  },
};

// ================================
// REDUCER
// ================================
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UNLOAD_ADD_NF_TO_LIST: {
      return {
        ...state,
        unloadSchedule: {
          ...state.unloadSchedule,
          nfList: [
            ...state.unloadSchedule.nfList,
            {
              ...action.nfObject,
            },
          ],
        },
      };
    }

    case UNLOAD_REMOVE_NF_FROM_LIST: {
      return {
        ...state,
        unloadSchedule: {
          ...state.unloadSchedule,
          nfList: state.unloadSchedule.nfList.filter(
            (nf, index) => action.nfIndex !== index,
          ),
        },
      };
    }

    case UNLOAD_CHANGE_TYPE: {
      return {
        ...state,
        unloadSchedule: {
          ...state.unloadSchedule,
          unloadType: action.newType,
        },
      };
    }

    case UNLOAD_EDIT_DAMAGED_NF: {
      return {
        ...state,
        unloadSchedule: {
          ...state.unloadSchedule,
          nfList: state.unloadSchedule.nfList.map((nf, index) => {
            if (index === action.nfIndex) {
              return {
                ...nf,
                isDamaged: !nf.isDamaged,
              };
            }

            return nf;
          }),
        },
      };
    }

    case UNLOAD_EDIT_PALLETIZED_NF: {
      return {
        ...state,
        unloadSchedule: {
          ...state.unloadSchedule,
          nfList: state.unloadSchedule.nfList.map((nf, index) => {
            if (index === action.nfIndex) {
              return {
                ...nf,
                isPalletized: !nf.isPalletized,
              };
            }

            return nf;
          }),
        },
      };
    }

    case CHANGE_STEP: {
      return {
        ...state,
        currentStep: action.step,
      };
    }

    case NEXT_STEP: {
      return {
        ...state,
        currentStep: action.step,
        availableStep:
          action.step < state.availableStep ? state.availableStep : action.step,
      };
    }

    case SELECT_TYPE: {
      return {
        ...initialState,
        currentType: action.currentType,
        availableStep: 1,
      };
    }

    case LOAD_SELECT_NF: {
      return {
        ...state,
        loadSchedule: {
          ...state.loadSchedule,
          nfSelectedsList: state.loadSchedule.nfSelectedsList.includes(
            action.nfObject,
          )
            ? state.loadSchedule.nfSelectedsList.filter(
                obj => obj !== action.nfObject,
              )
            : state.loadSchedule.nfSelectedsList.concat(action.nfObject),
        },
      };
    }

    case LOAD_GET_NF_LIST: {
      return {
        ...state,
        loadSchedule: {
          ...state.loadSchedule,
          nfList: {
            ...state.loadSchedule.nfList,
            isFetching: true,
            requested: action.requested,
          },
        },
      };
    }

    case LOAD_GET_NF_LIST_SUCCESS: {
      return {
        ...state,
        loadSchedule: {
          ...state.loadSchedule,
          nfList: {
            ...state.loadSchedule.nfList,
            isFetching: false,
            list: action.data,
            totalItems: action.totalItems,
          },
        },
      };
    }

    case LOAD_GET_NF_LIST_FAILURE: {
      return {
        ...state,
        loadSchedule: {
          ...state.loadSchedule,
          nfList: {
            ...state.loadSchedule.nfList,
            isFetching: false,
            error: action.error,
          },
        },
      };
    }

    case GET_DRIVERS: {
      return {
        ...state,
        drivers: {
          ...state.drivers,
          isFetching: true,
          requested: action.requested,
        },
      };
    }

    case GET_DRIVERS_SUCCESS: {
      return {
        ...state,
        drivers: {
          ...state.drivers,
          isFetching: false,
          list: action.data,
        },
      };
    }

    case GET_DRIVERS_FAILURE: {
      return {
        ...state,
        drivers: {
          ...state.drivers,
          isFetching: false,
          error: action.error,
        },
      };
    }

    case GET_VEHICLES: {
      return {
        ...state,
        vehicles: {
          ...state.vehicles,
          isFetching: true,
          requested: action.requested,
        },
      };
    }

    case GET_VEHICLES_SUCCESS: {
      return {
        ...state,
        vehicles: {
          ...state.vehicles,
          isFetching: false,
          list: action.data.map(v => ({
            ...v,
            name: `${v.model} - ${v.plate}`,
          })),
        },
      };
    }

    case GET_VEHICLES_FAILURE: {
      return {
        ...state,
        vehicles: {
          ...state.vehicles,
          isFetching: false,
          error: action.error,
        },
      };
    }

    case GET_AVAILABLE_DATES: {
      return {
        ...state,
        availableDates: {
          ...state.availableDates,
          isFetching: true,
          requested: action.requested,
        },
      };
    }

    case GET_AVAILABLE_DATES_SUCCESS: {
      return {
        ...state,
        availableDates: {
          ...state.availableDates,
          isFetching: false,
          list: action.data,
        },
      };
    }

    case GET_AVAILABLE_DATES_FAILURE: {
      return {
        ...state,
        availableDates: {
          ...state.availableDates,
          isFetching: false,
          error: action.error,
        },
      };
    }

    case GET_AVAILABLE_HOURS: {
      return {
        ...state,
        availableHours: {
          ...state.availableHours,
          isFetching: true,
          requested: action.requested,
        },
      };
    }

    case GET_AVAILABLE_HOURS_SUCCESS: {
      return {
        ...state,
        availableHours: {
          ...state.availableHours,
          isFetching: false,
          list: action.data,
        },
      };
    }

    case GET_AVAILABLE_HOURS_FAILURE: {
      return {
        ...state,
        availableHours: {
          ...state.availableHours,
          isFetching: false,
          error: action.error,
        },
      };
    }

    case SELECT_DRIVER_LOAD: {
      return {
        ...state,
        loadSchedule: {
          ...state.loadSchedule,
          isFetching: false,
          selectedDriver: action.driver,
        },
      };
    }

    case SELECT_DRIVER_UNLOAD: {
      return {
        ...state,
        unloadSchedule: {
          ...state.unloadSchedule,
          isFetching: false,
          selectedDriver: action.driver,
        },
      };
    }

    case SELECT_VEHICLE_LOAD: {
      return {
        ...state,
        loadSchedule: {
          ...state.loadSchedule,
          isFetching: false,
          selectedVehicle: action.vehicle,
        },
      };
    }

    case SELECT_VEHICLE_UNLOAD: {
      return {
        ...state,
        unloadSchedule: {
          ...state.unloadSchedule,
          isFetching: false,
          selectedVehicle: action.vehicle,
        },
      };
    }

    case SELECT_DAY: {
      return {
        ...state,
        selectedDay: action.day,
      };
    }

    case SELECT_SCHEDULES: {
      return {
        ...state,
        selectedSchedules: action.dates,
        loadSchedule: {
          ...state.loadSchedule,
          dateTimeFrom:
            state.currentType === 0
              ? `${moment(state.selectedDay).format('YYYY-MM-DD')} ${
                  state.selectedSchedules[0]
                }:00:00`
              : state.loadSchedule.dateTimeFrom,
          dateTimeTo:
            state.currentType === 0
              ? `${moment(state.selectedDay).format('YYYY-MM-DD')} ${
                  state.selectedSchedules[state.selectedSchedules.length - 1] +
                  1
                }:00:00`
              : state.loadSchedule.dateTimeTo,
        },
        unloadSchedule: {
          ...state.unloadSchedule,
          dateTimeFrom:
            state.currentType === 0
              ? state.unloadSchedule.dateTimeFrom
              : `${moment(state.selectedDay).format('YYYY-MM-DD')} ${
                  state.selectedSchedules[0]
                }:00:00`,
          dateTimeTo:
            state.currentType === 0
              ? state.unloadSchedule.dateTimeTo
              : `${moment(state.selectedDay).format('YYYY-MM-DD')} ${
                  state.selectedSchedules[state.selectedSchedules.length - 1] +
                  1
                }:00:00`,
        },
      };
    }

    case LOCK_SCHEDULES: {
      return {
        ...state,
        lockScheduleStatus: action.status,
      };
    }

    case ADD_SCHEDULE: {
      return {
        ...state,
        addSchedule: {
          ...state.addSchedule,
          isFetching: true,
          requested: action.requested,
        },
      };
    }

    case ADD_SCHEDULE_SUCCESS: {
      return {
        ...state,
        addSchedule: {
          ...state.addSchedule,
          isFetching: false,
        },
      };
    }

    case ADD_SCHEDULE_FAILURE: {
      return {
        ...state,
        addSchedule: {
          ...state.addSchedule,
          isFetching: false,
          error: action.error,
        },
      };
    }

    case ADD_SCHEDULE_CLEAR: {
      return {
        ...initialState,
      };
    }

    case GET_PACKAGING_TYPES: {
      return {
        ...state,
        packagingTypes: {
          ...state.packagingTypes,
          isFetching: true,
          requested: action.requested,
        },
      };
    }

    case GET_PACKAGING_TYPES_SUCCESS: {
      return {
        ...state,
        packagingTypes: {
          ...state.packagingTypes,
          isFetching: false,
          list: action.data,
        },
      };
    }

    case GET_PACKAGING_TYPES_FAILURE: {
      return {
        ...state,
        packagingTypes: {
          ...state.packagingTypes,
          isFetching: false,
          error: action.error,
        },
      };
    }

    default: {
      return state;
    }
  }
}

// ================================
// ACTION CREATORS
// ================================
function _loadGetNfList() {
  return {
    type: LOAD_GET_NF_LIST,
  };
}

function _loadGetNfListSuccess(data, totalItems) {
  return {
    type: LOAD_GET_NF_LIST_SUCCESS,
    data,
    totalItems,
  };
}

function _loadGetNfListFailure(error) {
  return {
    type: LOAD_GET_NF_LIST_FAILURE,
    error,
  };
}

function _getDrivers() {
  return {
    type: GET_DRIVERS,
  };
}

function _getDriversSuccess(data) {
  return {
    type: GET_DRIVERS_SUCCESS,
    data,
  };
}

function _getDriversFailure(error) {
  return {
    type: GET_DRIVERS_FAILURE,
    error,
  };
}

function _getVehicles() {
  return {
    type: GET_VEHICLES,
  };
}

function _getVehiclesSuccess(data) {
  return {
    type: GET_VEHICLES_SUCCESS,
    data,
  };
}

function _getVehiclesFailure(error) {
  return {
    type: GET_VEHICLES_FAILURE,
    error,
  };
}

function _getAvailableDates() {
  return {
    type: GET_AVAILABLE_DATES,
  };
}

function _getAvailableDatesSuccess(data) {
  return {
    type: GET_AVAILABLE_DATES_SUCCESS,
    data,
  };
}

function _getAvailableDatesFailure(error) {
  return {
    type: GET_AVAILABLE_DATES_FAILURE,
    error,
  };
}

function _getAvailableHours() {
  return {
    type: GET_AVAILABLE_HOURS,
  };
}

function _getAvailableHoursSuccess(data) {
  return {
    type: GET_AVAILABLE_HOURS_SUCCESS,
    data,
  };
}

function _getAvailableHoursFailure(error) {
  return {
    type: GET_AVAILABLE_HOURS_FAILURE,
    error,
  };
}

function _addSchedule() {
  return {
    type: ADD_SCHEDULE,
  };
}

function _addScheduleSuccess() {
  return {
    type: ADD_SCHEDULE_SUCCESS,
  };
}

function _addScheduleFailure(error) {
  return {
    type: ADD_SCHEDULE_FAILURE,
    error,
  };
}

function _addScheduleClear() {
  return {
    type: ADD_SCHEDULE_CLEAR,
  };
}

function _getPackagingTypes() {
  return {
    type: GET_PACKAGING_TYPES,
  };
}

function _getPackagingTypesSuccess(data) {
  return {
    type: GET_PACKAGING_TYPES_SUCCESS,
    data,
  };
}

function _getPackagingTypesFailure(error) {
  return {
    type: GET_PACKAGING_TYPES_FAILURE,
    error,
  };
}

// ================================
// PUBLIC ACTION CREATORS
// ================================
export function unloadAddNfToList(nfObject) {
  return {
    type: UNLOAD_ADD_NF_TO_LIST,
    nfObject,
  };
}

export function unloadChangeType(newType) {
  return {
    type: UNLOAD_CHANGE_TYPE,
    newType,
  };
}

export function unloadRemoveNfFromList(nfIndex) {
  return {
    type: UNLOAD_REMOVE_NF_FROM_LIST,
    nfIndex,
  };
}

export function unloadEditDamagedNf(nfIndex) {
  return {
    type: UNLOAD_EDIT_DAMAGED_NF,
    nfIndex,
  };
}

export function unloadEditPalletizedNf(nfIndex) {
  return {
    type: UNLOAD_EDIT_PALLETIZED_NF,
    nfIndex,
  };
}

export function loadSelectNf(nfObject) {
  return {
    type: LOAD_SELECT_NF,
    nfObject,
  };
}

export function changeStep(step) {
  return {
    type: CHANGE_STEP,
    step,
  };
}

export function nextStep(step) {
  return {
    type: NEXT_STEP,
    step,
  };
}

export function selectType(currentType) {
  return {
    type: SELECT_TYPE,
    currentType,
  };
}

export function selectDriver(driver, type) {
  return {
    type: type === 0 ? SELECT_DRIVER_LOAD : SELECT_DRIVER_UNLOAD,
    driver,
  };
}

export function selectVehicle(vehicle, type) {
  return {
    type: type === 0 ? SELECT_VEHICLE_LOAD : SELECT_VEHICLE_UNLOAD,
    vehicle,
  };
}

export function selectDate(day) {
  return {
    type: SELECT_DAY,
    day,
  };
}

export function selectSchedules(dates) {
  return {
    type: SELECT_SCHEDULES,
    dates,
  };
}

export function lockSchedule(status) {
  return {
    type: LOCK_SCHEDULES,
    status,
  };
}

// ================================
// THUNKS
// ================================
export function loadGetNfList(page = 1, amount = 10, query = '') {
  return function (dispatch) {
    const requested = moment().format();
    dispatch(_loadGetNfList(requested));

    (async () => {
      const params = {
        page,
        amount,
        query,
      };
      const response = await luftGet(
        '/Scheduling/GetAvailableNFsForLoad',
        params,
      );

      try {
        dispatch(
          _loadGetNfListSuccess(
            response.data.scheduleNfList,
            response.data.totalItems,
          ),
        );
      } catch (err) {
        dispatch(_loadGetNfListFailure(err));
      }
    })();
  };
}

export function getDrivers() {
  return function (dispatch) {
    const requested = moment().format();
    dispatch(_getDrivers(requested));

    (async () => {
      const response = await luftGet('/Scheduling/GetDrivers');
      try {
        dispatch(_getDriversSuccess(response.data));
      } catch (err) {
        dispatch(_getDriversFailure(err));
      }
    })();
  };
}

export function getVehicles() {
  return function (dispatch) {
    const requested = moment().format();
    dispatch(_getVehicles(requested));

    (async () => {
      const response = await luftGet('/Scheduling/GetVehicles');
      try {
        dispatch(_getVehiclesSuccess(response.data));
      } catch (err) {
        dispatch(_getVehiclesFailure(err));
      }
    })();
  };
}

export function getAvailableDates() {
  return function (dispatch) {
    const requested = moment().format();
    dispatch(_getAvailableDates(requested));

    (async () => {
      const response = {
        data: [26, 10, 31, 22, 24, 20, 15, 21],
      };

      try {
        dispatch(_getAvailableDatesSuccess(response.data));
      } catch (err) {
        dispatch(_getAvailableDatesFailure(err));
      }
    })();
  };
}

export function getAvailableHours(date) {
  return function (dispatch) {
    const requested = moment().format();
    dispatch(_getAvailableHours(requested));

    const params = {
      date,
    };

    (async () => {
      const response = await luftGet('/Scheduling/getAvailableHours', params);
      try {
        dispatch(
          _getAvailableHoursSuccess(
            response.data.filter(v =>
              [
                5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21,
                22, 23,
              ].includes(v),
            ),
          ),
        );
      } catch (err) {
        dispatch(_getAvailableHoursFailure(err));
      }
    })();
  };
}

export function addSchedule(scheduleData) {
  return function (dispatch) {
    const requested = moment().format();
    dispatch(_addSchedule(requested));

    (async () => {
      await luftPost('/Scheduling/AddSchedule', scheduleData);
      try {
        dispatch(_addScheduleSuccess());
        dispatch(_addScheduleClear());
      } catch (err) {
        dispatch(_addScheduleFailure(err));
      }
    })();
  };
}

export function getPackagingTypes() {
  return function (dispatch) {
    const requested = moment().format();
    dispatch(_getPackagingTypes(requested));

    (async () => {
      const response = await luftGet('/Scheduling/GetPackagingTypes');
      try {
        dispatch(_getPackagingTypesSuccess(response.data));
      } catch (err) {
        dispatch(_getPackagingTypesFailure(err));
      }
    })();
  };
}
